function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-beautiful-dnd';
import Droppable from "./Droppable";
import { getRest } from "../../utils";

/**
 * Drag Drop container.
 *
 * @class DragDrop
 * @extends {React.Component}
 */
import { jsx as _jsx } from "react/jsx-runtime";
var DragDrop = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(DragDrop, _React$PureComponent);
  function DragDrop() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    /**
       * Handle drag end.
       *
       * @memberof DragDrop
       */
    _this.handleDragEnd = function (result) {
      if (!result.destination || result.destination.index === result.source.index) {
        return;
      }

      // no movement
      if (result.destination.index === result.source.index) {
        return;
      }
      _.invoke(_this.props, 'onDragEnd', result);
    };
    /**
       *
       * @memberof DragDrop
       */
    _this.getListStyle = function () {
      var _this$props = _this.props,
        getListStyle = _this$props.getListStyle,
        horizontal = _this$props.horizontal;
      var style = {};
      if (horizontal) {
        style = Object.assign({}, style, {
          display: 'flex'
        });
      }
      if (getListStyle) {
        style = Object.assign({}, style, getListStyle());
      }
      return style;
    };
    return _this;
  }
  var _proto = DragDrop.prototype;
  /**
     * Render the component.
     *
     * @returns
     * @memberof DragDrop
     */
  _proto.render = function render() {
    var _this$props2 = this.props,
      children = _this$props2.children,
      droppableId = _this$props2.droppableId,
      horizontal = _this$props2.horizontal,
      items = _this$props2.items,
      itemControl = _this$props2.itemControl,
      getItemStyle = _this$props2.getItemStyle,
      hidePlaceholder = _this$props2.hidePlaceholder;
    var rest = getRest(DragDrop, this.props);
    if (!_.isNil(children) && !_.isEmpty(children)) {
      return /*#__PURE__*/_jsx(DragDropContext, Object.assign({
        onDragEnd: this.handleDragEnd
      }, rest, {
        children: children
      }));
    }
    return /*#__PURE__*/_jsx(DragDropContext, Object.assign({
      onDragEnd: this.handleDragEnd
    }, rest, {
      children: /*#__PURE__*/_jsx(Droppable, Object.assign({
        droppableId: droppableId,
        items: items,
        itemControl: itemControl,
        getListStyle: this.getListStyle,
        getItemStyle: getItemStyle
      }, horizontal ? {
        direction: 'horizontal'
      } : null, {
        hidePlaceholder: hidePlaceholder
      }))
    }));
  };
  return DragDrop;
}(React.PureComponent);
/**
 * Prop types.
 */
DragDrop.handledProps = ["children", "droppableId", "getItemStyle", "getListStyle", "hidePlaceholder", "horizontal", "itemControl", "items", "onDragEnd"];
DragDrop.propTypes = {
  /** Callback on drag end. */
  onDragEnd: PropTypes.func,
  /** Primary content. */
  children: PropTypes.node,
  /** Shorthand array of props for Draggable items. */
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.array,
  /** An item control component. */
  itemControl: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /** Droppable id. */
  droppableId: PropTypes.string,
  /** Function to get style list. */
  getListStyle: PropTypes.func,
  /** Function to get style item. */
  getItemStyle: PropTypes.func,
  /** A list of draggable items may appears horizontally. */
  horizontal: PropTypes.bool,
  /** Hide the placeholder while dragging. */
  hidePlaceholder: PropTypes.bool
};
export default DragDrop;